import { MessageFactory, UID_BYTES_PER_ELEMENT, BOOLEAN_BYTES_PER_ELEMENT, BusMessage } from "flavr-common";
/**
 * Requests a boolean mesh intersection test.
 */
export class BooleanMeshIntersectionRequestMessage extends BusMessage {
    get byteLength() {
        return (UID_BYTES_PER_ELEMENT + // modelUIDA
            UID_BYTES_PER_ELEMENT // modelUIDB
        );
    }
    constructor(modelUIDA, modelUIDB) {
        super();
        this.modelUIDA = modelUIDA;
        this.modelUIDB = modelUIDB;
    }
    serialization(stream) {
        this.modelUIDA = stream.uid(this.modelUIDA);
        this.modelUIDB = stream.uid(this.modelUIDB);
    }
    static is(msg) {
        return msg.type === BooleanMeshIntersectionRequestMessage.typestatic;
    }
}
BooleanMeshIntersectionRequestMessage.typestatic = "BooleanMeshIntersectionRequestMessage";
BooleanMeshIntersectionRequestMessage.subjectstatic = "collision";
MessageFactory.register(BooleanMeshIntersectionRequestMessage);
/**
 * Returns the result of a boolean mesh intersection test.
 */
export class BooleanMeshIntersectionResponseMessage extends BusMessage {
    get byteLength() {
        return BOOLEAN_BYTES_PER_ELEMENT; // intersected
    }
    constructor(intersected) {
        super();
        this.intersected = intersected;
    }
    serialization(stream) {
        this.intersected = stream.boolean(this.intersected);
    }
    static is(msg) {
        return msg.type === BooleanMeshIntersectionResponseMessage.typestatic;
    }
}
BooleanMeshIntersectionResponseMessage.typestatic = "BooleanMeshIntersectionResponseMessage";
BooleanMeshIntersectionResponseMessage.subjectstatic = "collision";
MessageFactory.register(BooleanMeshIntersectionResponseMessage);
